import type { CSSProperties, ReactNode } from 'react';

/** A column heading: text, or text with `num` for right-aligned numbers; null for an empty heading. */
export type Column = string | { label: string; num?: boolean } | null;

/** Table that turns into stacked cards under 720 px (cells carry `data-label`). */
export function DataTable({ columns, children, wrapStyle }: { columns: Column[]; children: ReactNode; wrapStyle?: CSSProperties }) {
  return (
    <div className="table-wrap" style={wrapStyle}>
      <table className="table responsive">
        <thead>
          <tr>
            {columns.map((c, i) => (c === null ? <th key={i} /> : typeof c === 'string' ? <th key={i}>{c}</th> : <th key={i} className={c.num ? 'num' : undefined}>{c.label}</th>))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
